/**
 * 提供 RTL 方向判断的 composable
 * 用于组件中需要 JS 动态判断文字方向的场景（如动画方向翻转、条件渲染等）
 */
export const useRtl = () => {
  const { localeMeta } = useAppI18n()
  const isRtl = computed(() => localeMeta.dir === 'rtl')
  const dir = computed(() => localeMeta.dir)

  return { isRtl, dir }
}
